import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCreateUserMutation } from '../../Api/users';
import { formatPhoneNumber } from '../../Helpers/phone-formatter';
import useTranslate from '../../Hooks/useTranslate';
import Button from '../../Style-guide/Button';
import Input from '../../Style-guide/Input';
import Text from '../../Style-guide/Text';
import Title from '../../Style-guide/Title';
import notify from '../../Style-guide/ToastMessage';
import SignUpWrapper from './style/signUpWrapper';
import { validate } from './validator';
import VerificationModal from './verificationModal';

const fields = {
  firstName: '',
  lastName: '',
  phone: '',
  password: '',
  confirmPassword: '',
};

const SignUp = () => {
  const navigate = useNavigate();
  const tr = useTranslate();

  const [formData, setFormData] = useState({ ...fields });
  const [errors, setErrors] = useState({ ...fields });
  const [showModal, setShowModal] = useState(false);

  const { mutate: createUserRequest, isSuccess, data } = useCreateUserMutation();

  // useEffect(() => {
  //   if (isSuccess && data?.message) {
  //     notify.success(tr(data.translationKey) || data.message);
  //     navigate('/signin');
  //   }
  // }, [data, isSuccess, navigate, tr]);

  useEffect(() => {
    if (!isSuccess) {
      setShowModal(false);
    }

    if (isSuccess && data) {
      if (!data.isVerified) {
        setShowModal(true);
      }

      if (data.isVerified && (data.translationKey || data.message)) {
        setShowModal(false);
        notify.success(tr(data.translationKey) || data.message);
        navigate('/signin');
      }
    }
  }, [data, isSuccess, navigate, tr]);

  const handleChange = (e) => {
    const { name } = e.target;
    let { value } = e.target;

    if (name === 'phone') {
      value = formatPhoneNumber(value);
    }

    const validated = validate(name, value, formData.password);

    if (!validated.isValid) {
      // setErrors({ ...errors, [name]: validated.message });
      setErrors({
        ...errors,
        [name]: tr(validated.translationKey, { isError: true }) || validated.message,
      });
    } else {
      setErrors({ ...errors, [name]: '' });
    }

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const isValid =
      Object.values(errors).every((error) => error === '') &&
      Object.values(formData).every((value) => value.length > 0);

    if (isValid) {
      createUserRequest({ data: formData });
    } else {
      for (const [field, value] of Object.entries(formData)) {
        if (!value.length) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            [field]: tr('this_field_is_required', { isError: true }),
          }));
        }
      }
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleSubmit(event);
    }
  };

  return (
    <SignUpWrapper>
      <Title size='MD' className='page-title'>
        {tr('sign_up')}
      </Title>

      <div className='container'>
        <form onSubmit={handleSubmit} onKeyDown={handleKeyDown}>
          <div className='fields-container'>
            <Input
              type='text'
              label={tr('first_name')}
              value={formData.firstName}
              name='firstName'
              onChange={handleChange}
              autoComplete='off'
              error={errors.firstName}
            />
            <Input
              type='text'
              label={tr('last_name')}
              value={formData.lastName}
              name='lastName'
              onChange={handleChange}
              autoComplete='off'
              error={errors.lastName}
            />
            <Input
              type='tel'
              label={tr('phone_number')}
              value={formData.phone}
              name='phone'
              onChange={handleChange}
              autoComplete='off'
              error={errors.phone}
            />
          </div>
          <div className='fields-container'>
            <Input
              type='password'
              label={tr('password')}
              value={formData.password}
              name='password'
              onChange={handleChange}
              autoComplete='off'
              error={errors.password}
            />
            <Input
              type='password'
              label={tr('confirm_password')}
              value={formData.confirmPassword}
              name='confirmPassword'
              onChange={handleChange}
              autoComplete='off'
              error={errors.confirmPassword}
            />
            <Button type='submit' className='submit-btn' $block>
              {tr('register')}
            </Button>
          </div>
        </form>
      </div>

      <Text size='SM' className='have-account-text'>
        {tr('already_have_account')}
        <Link to='/signin' className='link-to-sign-in'>
          {tr('sign_in')}
        </Link>
      </Text>

      <VerificationModal
        showModal={showModal}
        setShowModal={setShowModal}
        userData={formData}
        request={createUserRequest}
      />
    </SignUpWrapper>
  );
};

export default SignUp;
